'use strict';

module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/chart.js/src/charts/Chart.Radar.js
// module id = ../../../../chart.js/src/charts/Chart.Radar.js
// module chunks = 3